<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="设备名称/终端号/IMEI">
          <el-input placeholder="请输入设备名称/终端号/IMEI" v-model="formInline.search">

          </el-input>
        </el-form-item>

        <el-form-item label="售后人员/售后人员手机号">
          <el-input placeholder="请输入售后人员/售后人员手机号" v-model="formInline.sales">

          </el-input>
        </el-form-item>

        <el-form-item label="投入场地">
          <el-input style="width: 200px;" placeholder="请输入投入场地" v-model="formInline.address">

          </el-input>
        </el-form-item>


        <el-form-item label="状态">
          <el-select size="small" v-model="formInline.status" placeholder="请选择状态">
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="启用" :value="1"></el-option>
            <el-option label="停用" :value="0"></el-option>
          </el-select>
        </el-form-item>


        <el-form-item>

            <el-button type="primary"  icon="el-icon-search" @click="getData">查询</el-button>
            <el-button  icon="el-icon-search" @click="reast">重置</el-button>

        </el-form-item>

      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加设备</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="equip_id" label="ID"></el-table-column>
            <el-table-column prop="detail" label="投放场地"></el-table-column>
            <el-table-column prop="name" label="设备名称"></el-table-column>

            <el-table-column prop="avatarUrl" label="设备封面">
            <template slot-scope="scope">
              <div v-if="scope.row.cover">
                <img :src="scope.row.cover" width="60px" height="60px"
              
                />
              </div>
            </template>
          </el-table-column>  

          <el-table-column prop="name" label="设备照片" width="200">
                <template  slot-scope="scope">
                  <div style="height: 80px;width:210px; overflow-x:auto;">
                    <div v-for="(item,index) in scope.row.images" :key="index" style="float: left;">
                      <el-image style="width: 50px; height: 50px;" :src="item.file_path" fit="fit"
                      ref="preview" :preview-src-list="scope.row.images_arr"
                      ></el-image>
                    </div>
                    <div style="clear: both;"></div>
                  </div>
                  
                  
                </template>

            </el-table-column>


            <el-table-column prop="equip_no" label="设备终端号"></el-table-column>
            <el-table-column prop="equip_imei" label="设备IMEI"></el-table-column>
            <el-table-column prop="sales_people" label="售后人员">
              <template slot-scope="scope">
                <div v-if=" scope.row.sales_people">姓名：{{ scope.row.sales_people }}</div>
                <div v-if=" scope.row.sales_phone">联系方式：{{ scope.row.sales_phone }}</div>
              </template>
            </el-table-column>

            <!-- <el-table-column prop="type" label="类型">
              <template slot-scope="scope">
                <div v-if="scope.row.type == 1">分佣模式</div>
              </template>
            </el-table-column>

     

            <el-table-column prop="service_rate" label="服务商分佣比例">
              <template slot-scope="scope">
                <div>{{ scope.row.service_rate }}%</div>
              </template>
            </el-table-column>
 -->



            <el-table-column prop="time" label="状态">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#ff4949" @change="isDefaultChange(scope.row)"></el-switch>

              </template>
            </el-table-column>

            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="openPopup(scope.row,'equip')" type="text" size="small">二维码</el-button>
                <el-button @click="detailClick(scope.row)" type="text" size="small">收入明细</el-button>
                <el-button @click="peopleClick(scope.row)" type="text" size="small">人员设置</el-button>
                <el-button @click="packageClick(scope.row)" type="text" size="small">套餐</el-button>
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :equip_id="equip_id"  v-if="open_edit"   @close="closeEdit"></Edit>
    <Package :open_package_add="open_package_add" v-if="open_package_add" :equip_id="equip_id" @close="closePackageFunc"></Package>
    <People :open_add="open_people" v-if="open_people" :equip_id="equip_id" @close="closePeople"></People>
    <LinkPage v-if="show_path" :is_open="show_path" :path_type="path_type" :dataModel="dataModel" @closeDialog="closeDialogFunc($event, 'path')"></LinkPage>

 </div>
</template>

<script>
  import EquipApi from '@/api/equip.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';
  import People from './belong/log.vue';
  import Package from './part/package/index.vue'
  import LinkPage from '@/components/page/path';
import qs from 'qs';
  export default {
    components: {
      Add,
      Edit,
      Package,
      People,
      LinkPage,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:"",
          sales:"",
          status:-1,
          address:""
        },

        open_add:false,
        open_edit:false,
        equip_id:"",
        open_package_add:false,
        open_people:false,

        show_path:false,
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();
    },
    methods: {
      openPopup(item,type){
        this.dataModel = item;
        this.dataModel.wxapp_id = this.wxapp_id;
        this.show_path = true;
        this.path_type = type;
      },
        /*关闭弹窗*/
      closeDialogFunc(e, f) {
        if (f == 'upload') {
            this.open_upload = e.openDialog;
            if (e.type == 'success') {
                  this.getData();
            }
        }else if(f == 'action'){
          this.more_actions = e.openDialog;
          if (e.type == 'success') {
                this.getData();
          }
        }else if (f == 'path') {
              this.show_path = e.openDialog;
          }
    },

      isDefaultChange(row) {
      let self = this
      self.$confirm('是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let status = 1;
        if(row.status){
          status = 1;
        }else{
          status = 0;
        }
        self.loading = true;
        EquipApi.setStatus({status:status,equip_id:row.equip_id}, true).then(data => {
          console.log(data)
          if (data.code === 1) {
            self.loading = false;
            self.$message({
              message: '恭喜你，操作成功',
              type: 'success'
            });
            self.getTableList();
          } else {
            self.loading = false;
          }
        }).catch(error => {
          self.loading = false;
        });
      }).catch(() => {
        row.is_default = !row.is_default
      })
    },
      reast(){
        this.formInline = {
          search:"",
          sales:"",
          status:-1,
          address:""
        };
        this.getTableList();
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    closePackageFunc(){
      this.getData();
      this.open_package_add = false
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        EquipApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
            for(var i=0;i<self.tableData.length;i++){
              self.tableData[i].status = self.tableData[i].status==1?true:false;
            }
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },
      packageClick(row){
        let self = this;
        self.open_package_add = true
        self.equip_id = row.equip_id;
      },
      peopleClick(row){//绑定人员
        let self = this;
        self.open_people = true
        self.equip_id = row.equip_id;
      },
      closePeople(){
        let self = this;
        self.open_people = false
      },
      detailClick(row){
        let self = this;
        self.$router.push({
          path: '/plus/equip/index',
          query: {
            type: "log",
            equip_no:row.equip_no
          }
        });
      },
      /*编辑活动*/
      editClick(row) {
        this.equip_id = row.equip_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            EquipApi.del(
              {
                equip_id: row.equip_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/equip/equip/index.vue